import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useContext } from 'react';

import DatePicker from './DatePicker';
import classNames from 'classnames';
import AppContext from 'context/Context';
import useApi from 'hooks/useApi';
import {
  getProjectDetails,
  updateProject
} from 'api/endpoints/ManagementServices';
import { isEmpty } from 'lodash';
import { has } from 'lodash';
import { get } from 'lodash';
import MapLayers from './MapLayers';

import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  OverlayTrigger,
  Row,
  ToggleButton
} from 'react-bootstrap';
import format from 'date-fns/format';
import Loader from 'components/common/Loader';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faFileUpload,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';

import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

import wellknown from 'wellknown';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { isEqual } from 'lodash';
import { parseISO } from 'date-fns';
import {
  DownloadBoundaryTemplatePopover,
  UploadBoundaryFilePopover
} from './Popover';
import { jwtDecode } from 'jwt-decode';
import { getTenantFromToken } from 'utils/routeUtils';

const EditProject = () => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const tenant = getTenantFromToken();
  const { request_id } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  const [isEditable, setIsEditable] = useState(false);
  const [isMapEditable, setIsMapEditable] = useState(true);
  const [isMapEdited, setIsMapEdited] = useState(false);
  const [isMapDeleted, setIsMapDeleted] = useState(false);
  const [isMonitoringEditable, setIsMonitoringEditable] = useState(false);
  const [isEvaluationEditable, setIsEvaluationEditable] = useState(false);

  const [projectDetails, setProjectDetails] = useState({});
  const [evaluationEnabled, setEvaluationEnabled] = useState(true);
  const [monitoringEnabled, setMonitoringEnabled] = useState(false);
  const [monitoringStartDate, setMonitoringStartDate] = useState(null);
  const [monitoringEndDate, setMonitoringEndDate] = useState(null);
  const [frequency, setFrequency] = useState('Monthly');

  const [mapLayer, setMapLayer] = useState(null);

  const [plotUploadFile, setPlotUploadFile] = useState(false);
  const [hasLayer, setHasLayer] = useState(true);
  const [geojsonData, setGeojsonData] = useState({});
  const [area, setArea] = useState(0);
  const mapRef = useRef();
  const drawnShapeRef = useRef(null);
  const featureGroupRef = useRef();

  const [startDateError, setStartDateError] = useState('');
  const [endDateError, setEndDateError] = useState('');
  const [plotError, setPlotError] = useState('');

  const updateProjectAPI = useApi(updateProject);
  const getProjectDetailsAPI = useApi(getProjectDetails);

  useEffect(() => {
    if (pathname.includes('edit')) {
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  }, [pathname]);

  const fetchProjectDetails = () => {
    setLoading(true);
    Promise.all([
      getProjectDetailsAPI.request({
        tenant: tenant,
        request_id: request_id
      })
    ]).then(() => {
      setLoading(false);
    });
  };
  useEffect(() => {
    fetchProjectDetails();
  }, []);

  useEffect(() => {
    if (!isEmpty(getProjectDetailsAPI.error)) {
      navigate('/errors/404');
    }
  }, [getProjectDetailsAPI.error]);

  useEffect(() => {
    const data = get(getProjectDetailsAPI.data, 'results', {});
    setProjectDetails(data);
  }, [getProjectDetailsAPI.data]);

  const GeometryToFeatureCollection = geometry => ({
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: geometry,
        properties: {}
      }
    ]
  });

  // const updateStateData = projectDetails => {
  //   setEvaluationEnabled(projectDetails.evaluation_status);
  //   setMonitoringEnabled(projectDetails.monitoring_status);

  //   if (projectDetails.monitoring_status) {
  //     setMonitoringStartDate(new Date(projectDetails.monitoring?.start_date));
  //     setMonitoringEndDate(new Date(projectDetails.monitoring?.end_date));
  //     setFrequency(projectDetails.monitoring?.frequency);
  //   } else {
  //     setMonitoringStartDate(null);
  //     setMonitoringEndDate(null);
  //     setFrequency('monthly');
  //   }

  //   if (projectDetails?.coordinates) {
  //     const featureCollection = GeometryToFeatureCollection(
  //       wellknown.parse(projectDetails?.coordinates)
  //     );

  //     setUploadedGeojsonData(featureCollection);
  //     setGeojsonData(featureCollection);

  //     let newGeoJSONLayer = null;

  //     if (featureCollection.features[0].geometry.type === 'MultiPolygon') {
  //       const polygons = multiPolygonCollectionToPolygon(featureCollection);
  //       const featureGroup = L.featureGroup(polygons);
  //       newGeoJSONLayer = featureGroup;
  //     } else {
  //       newGeoJSONLayer = L.geoJSON(featureCollection);
  //     }

  //     if (newGeoJSONLayer) {
  //       const bounds = newGeoJSONLayer.getBounds();

  //       drawnShapeRef.current = {
  //         edit_id: newGeoJSONLayer._leaflet_id,
  //         del_id: newGeoJSONLayer._leaflet_id
  //       };

  //       if (mapRef.current) {
  //         mapRef.current.fitBounds(bounds);
  //         newGeoJSONLayer.addTo(mapRef.current);
  //       }

  //       setUploadedGeoJSONLayer(newGeoJSONLayer);
  //       setHasLayer(true);

  //       setArea(parseFloat(projectDetails?.project_area));
  //     }
  //   }
  // };

  const updateStateData = projectDetails => {
    setEvaluationEnabled(projectDetails.evaluation_status);
    setMonitoringEnabled(projectDetails.monitoring_status);
    if (projectDetails.monitoring_status) {
      setMonitoringStartDate(new Date(projectDetails.monitoring?.start_date));
      setMonitoringEndDate(new Date(projectDetails.monitoring?.end_date));
      setFrequency(projectDetails.monitoring?.frequency);
    } else {
      setMonitoringStartDate(null);
      setMonitoringEndDate(null);
      setFrequency('monthly');
    }
    if (projectDetails?.coordinates) {
      const featureCollection = GeometryToFeatureCollection(
        wellknown.parse(projectDetails?.coordinates)
      );
      console.log(featureCollection, 'featureCollection');
      setUploadedGeojsonData(featureCollection);
      setGeojsonData(featureCollection);

      let newGeoJSONLayer = {};

      if (featureCollection.features[0].geometry.type === 'MultiPolygon') {
        newGeoJSONLayer = L.geoJSON(
          multiPolygonCollectionToPolygon(featureCollection)
        );
      } else {
        newGeoJSONLayer = L.geoJSON(featureCollection);
      }

      if (newGeoJSONLayer) {
        const layer = Object.values(newGeoJSONLayer._layers)[0];
        console.log(layer, 'newGeoJSONLayer');
        setUploadedGeoJSONLayer(layer);
        const bounds = layer.getBounds();

        drawnShapeRef.current = {
          edit_id: layer._leaflet_id,
          del_id: layer._leaflet_id
        };
        setHasLayer(true);

        if (mapRef.current) {
          mapRef.current.fitBounds(bounds);
        }
        setArea(parseFloat(projectDetails?.project_area));
      }
    }
  };

  // const multiPolygonCollectionToPolygon = mp => {
  //   return mp;
  // };

  const multiPolygonCollectionToPolygon = mp => {
    const features = mp.features.flatMap(feat => {
      const { geometry: geom, properties: props } = feat;
      if (geom.type === 'MultiPolygon') {
        return geom.coordinates.map(coordinates => ({
          type: 'Polygon',
          coordinates,
          properties: props
        }));
      }
      return [];
    });
    return {
      type: 'FeatureCollection',
      features
    };
  };

  // const multiPolygonCollectionToPolygon = mp => {
  //   let flattenedCoordinates = [];
  //   let properties = {};

  //   mp.features.forEach(feat => {
  //     const { geometry: geom, properties: props } = feat;
  //     if (geom.type === 'MultiPolygon') {
  //       geom.coordinates.forEach(coordinates => {
  //         flattenedCoordinates.push(...coordinates.flat(1));
  //       });
  //       properties = props; // Update properties to the last set of properties found
  //     }
  //   });
  //   console.log(
  //     flattenedCoordinates,
  //     'flattenedCoordinatesflattenedCoordinates'
  //   );
  //   // Return a single feature with flattened coordinates and properties
  //   return {
  //     type: 'FeatureCollection',
  //     features: [
  //       {
  //         type: 'Feature',
  //         geometry: {
  //           type: 'Polygon',
  //           coordinates: [flattenedCoordinates]
  //         },
  //         properties: properties
  //       }
  //     ]
  //   };
  // };
  // const multiPolygonCollectionToPolygon = mp => {
  //   let flattenedCoordinates = [];
  //   let properties = {};

  //   mp.features.forEach(feat => {
  //     const { geometry: geom, properties: props } = feat;
  //     if (geom.type === 'MultiPolygon') {
  //       geom.coordinates.forEach(coordinates => {
  //         flattenedCoordinates.push(coordinates.flat(1));
  //       });
  //       properties = props; // Update properties to the last set of properties found
  //     }
  //   });
  //   // Return a single feature with flattened coordinates and properties
  //   return {
  //     type: 'FeatureCollection',
  //     features: [
  //       {
  //         type: 'Feature',
  //         geometry: {
  //           type: 'Polygon',
  //           coordinates: flattenedCoordinates
  //         },
  //         properties: properties
  //       }
  //     ]
  //   };
  // };

  useEffect(() => {
    updateStateData(projectDetails);
  }, [projectDetails]);

  useEffect(() => {
    if (
      projectDetails?.queue_status?.toLowerCase() === 'New'.toLowerCase() ||
      projectDetails?.queue_status?.toLowerCase() === 'Queued'.toLowerCase()
    ) {
      isEditing ? setIsMapEditable(true) : setIsMapEditable(false);
      isEditing
        ? setIsEvaluationEditable(true)
        : setIsEvaluationEditable(false);
      setIsEditable(true);
    }
    if (
      projectDetails.queue_status &&
      projectDetails.queue_status.toLowerCase() !== 'Processing'.toLowerCase()
    ) {
      isEditing
        ? setIsMonitoringEditable(true)
        : setIsMonitoringEditable(false);
      setIsEditable(true);
    } else if (projectDetails.queue_status) {
      setIsEditable(false);
    }
  }, [projectDetails, isEditing]);

  useEffect(() => {
    if (
      isEditing &&
      projectDetails.status &&
      projectDetails.status.toLowerCase() === 'Processing'.toLowerCase()
    ) {
      navigate('/errors/404');
    }
  }, [isEditing, projectDetails]);

  const handleShapeEdit = (layer, isNewShape = true) => {
    setPlotError('');

    let geojson;
    let area;

    if (layer instanceof L.Circle) {
      const circleToPolygon = L.PM.Utils.circleToPolygon(layer, 64);
      setMapLayer(circleToPolygon);
      geojson = circleToPolygon.toGeoJSON();
      area =
        L.GeometryUtil.geodesicArea(circleToPolygon.getLatLngs()[0]) / 10000;
    } else {
      setMapLayer(layer);
      geojson = layer.toGeoJSON();
      if (geojson.geometry.type === 'MultiPolygon') {
        let totalArea = 0;

        layer.getLatLngs().forEach(polygon => {
          const area = L.GeometryUtil.geodesicArea(polygon[0]);
          totalArea += area;
        });

        area = totalArea / 10000;
      } else {
        area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]) / 10000;
      }
    }

    // Update state with new GeoJSON data
    setGeojsonData({
      type: 'FeatureCollection',
      features: [geojson]
    });

    // Update state with new area
    setArea(area);

    if (isNewShape) {
      // Save layer id for editing and deleting
      drawnShapeRef.current = {
        edit_id: layer._leaflet_id,
        del_id: layer._leaflet_id
      };
      setHasLayer(true);
    }
  };

  const _onCreate = e => {
    handleShapeEdit(e.layer);
  };

  const _onEdited = e => {
    const {
      target: { _layers }
    } = e;
    const layer = _layers[drawnShapeRef.current.edit_id];
    setIsMapEdited(true);
    handleShapeEdit(layer, false);
  };

  const _onDeleted = e => {
    const {
      layers: { _layers }
    } = e;

    if (has(_layers, drawnShapeRef.current.del_id)) {
      setGeojsonData({});
      setMapLayer(null);
      setArea(0);
      setHasLayer(false);
      setUploadedGeoJSONLayer(null);
      setUploadedGeojsonData({});
      setUploadFile(null);
      setIsMapDeleted(true);
    }
  };

  useEffect(() => {
    if (!hasLayer && plotUploadFile) {
      setHasLayer(true);
    }
  }, [hasLayer]);

  const handleSubmit = event => {
    event.preventDefault(); // Prevent the default form submission
    if (!isEditing) return;

    let hasError = false;
    let hasPlotError = false;

    if (monitoringEnabled) {
      if (!monitoringStartDate) {
        setStartDateError('Please select a start date.');
        hasError = true;
      } else {
        setStartDateError('');
      }

      if (!monitoringEndDate) {
        setEndDateError('Please select an end date.');
        hasError = true;
      } else {
        setEndDateError('');
      }
    }

    const isNewMap = isMapEdited || isMapDeleted;

    if (isMapEditable && isNewMap) {
      if (!plotUploadFile && isEmpty(geojsonData)) {
        setPlotError('Please draw the plot boundary.');
        hasPlotError = true;
      } else {
        setPlotError('');
      }
      if (plotUploadFile && isEmpty(uploadedGeojsonData)) {
        setFileUploadError('Please upload file of valid format.');
        hasError = true;
      } else {
        setFileUploadError('');
      }
    }

    if (hasError) {
      window.scrollTo(0, 0);
      return;
    }

    // scroll to the Map container if only plot dawing has missing
    if (hasPlotError) {
      const element = document.querySelector('#map');
      const top = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: 'smooth' });
      return;
    }

    if (area === 0) {
      return;
    }

    let monitoringData = {
      enable_monitoring: projectDetails.monitoring_status,
      monitoring_start_date:
        projectDetails.monitoring?.monitoring_start_date || '',
      monitoring_end_date: projectDetails.monitoring?.monitoring_end_date || '',
      monitoring_frequency: projectDetails.monitoring?.frequency || ''
    };

    if (isMonitoringEditable) {
      monitoringData = {
        enable_monitoring: monitoringEnabled,
        monitoring_start_date: monitoringEnabled
          ? format(monitoringStartDate, 'dd-MM-yyyy')
          : '',
        monitoring_end_date: monitoringEnabled
          ? format(monitoringEndDate, 'dd-MM-yyyy')
          : '',
        monitoring_frequency: monitoringEnabled ? frequency : ''
      };
    }

    const requestData = {
      tenant: tenant,
      request_id: request_id,
      project_area: Math.round(area),
      ...monitoringData,
      feature: geojsonData,
      enable_evaluation: evaluationEnabled
    };

    // Check if there are any changes in the monitoring data or feature data
    const isMonitoringDataEdited = () => {
      if (!monitoringEnabled && !projectDetails.monitoring_status) {
        return false;
      } else {
        return (
          projectDetails.monitoring_status !== monitoringEnabled ||
          (projectDetails.monitoring?.start_date &&
            format(
              parseISO(projectDetails.monitoring?.start_date),
              'dd-MM-yyyy'
            ) !== monitoringData.monitoring_start_date) ||
          (projectDetails.monitoring?.end_date &&
            format(
              parseISO(projectDetails.monitoring?.end_date),
              'dd-MM-yyyy'
            ) !== monitoringData.monitoring_end_date) ||
          projectDetails.monitoring?.frequency !==
            monitoringData.monitoring_frequency
        );
      }
    };
    const isFeatureDataEdited = !isEqual(
      GeometryToFeatureCollection(wellknown.parse(projectDetails?.coordinates)),
      geojsonData
    );

    const isEvaluationEdited =
      projectDetails.evaluation_status !== evaluationEnabled;

    // Check if any changes are detected and show the error toast if not
    if (
      !isMonitoringDataEdited() &&
      !isFeatureDataEdited &&
      !isEvaluationEdited
    ) {
      // Show your error toast here
      toast.error('No changes detected');
      return;
    }

    updateProjectAPI.request(requestData);
  };

  useEffect(() => {
    if (updateProjectAPI.data?.success === true) {
      navigate(`/${tenant}/projects/${request_id}`);
      fetchProjectDetails();
      toast.success('Project edited successfully');
    }
  }, [updateProjectAPI.data]);

  useEffect(() => {
    if (!isEmpty(updateProjectAPI.error)) {
      // Show a toast message
      toast.error('An error occurred while updating the project.');
    }
  }, [updateProjectAPI.error]);

  useEffect(() => {
    if (updateProjectAPI.loading) {
      setRequestLoading(true);
    } else {
      setRequestLoading(false);
    }
  }, [updateProjectAPI.loading]);

  const [fileName, setFileName] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadedGeojsonData, setUploadedGeojsonData] = useState({});
  const [uploadedGeoJSONLayer, setUploadedGeoJSONLayer] = useState(null);
  const [fileUploadError, setFileUploadError] = useState('');

  const handleFileUploadClick = () => {
    document.getElementById('uploadBoundaryFileInput').click();
  };

  const handleFileChange = async e => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name;
      const fileExtension = getFileExtension(fileName);

      if (fileExtension === 'json' || fileExtension === 'csv') {
        try {
          const fileContents = await readFileContents(file);

          let data;
          if (fileExtension === 'json') {
            data = JSON.parse(fileContents);
          } else {
            data = parseCSVData(fileContents);
          }

          setUploadedGeojsonData(data);
          setUploadFile(file);
          setFileName(fileName);
          setFileUploadError('');

          const newGeoJSONLayer = L.geoJSON(data);
          const layer = Object.values(newGeoJSONLayer._layers)[0];
          setUploadedGeoJSONLayer(layer);

          const bounds = newGeoJSONLayer.getBounds();
          mapRef.current.fitBounds(bounds);

          setHasLayer(true);
          setGeojsonData(layer.toGeoJSON());
          handleShapeEdit(layer);
          drawnShapeRef.current.del_id = layer._leaflet_id;
          setMapLayer(layer);
        } catch (error) {
          console.error(error);
          setUploadFile(null);
          setFileName('');
          setFileUploadError('Error reading file contents.');
          setUploadedGeojsonData({});
        }
      } else {
        setUploadFile(null);
        setFileName('');
        setFileUploadError(
          'Invalid file format. Please upload a GeoJSON(.json) or WKT(.csv) file.'
        );
        setUploadedGeojsonData({});
      }
    }
  };

  const getFileExtension = fileName => {
    const fileParts = fileName.split('.');
    return fileParts[fileParts.length - 1].toLowerCase();
  };

  const readFileContents = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = event => {
        resolve(event.target.result);
      };
      reader.onerror = event => {
        reject(event.error);
      };
      reader.readAsText(file);
    });
  };

  const parseCSVData = csvData => {
    const result = Papa.parse(csvData, { header: true });
    const records = result.data;
    return {
      type: 'FeatureCollection',
      features: records
        .map(record => {
          try {
            return {
              type: 'Feature',
              geometry: wellknown.parse(record.wkt),
              properties: record
            };
          } catch (error) {
            console.error(error);
            return null;
          }
        })
        .filter(feature => feature !== null)
    };
  };

  function handleDownloadTemplate(e) {
    const selectedValue = e.target.value;
    let fileUrl, fileName;
    if (selectedValue === 'geojson') {
      fileUrl = '/json/geojson_sample.json';
      fileName = 'geojson_sample.json';
    } else if (selectedValue === 'wkt') {
      fileUrl = '/json/wkt_sample.csv';
      fileName = 'wkt_sample.csv';
    }
    saveAs(fileUrl, fileName);
  }

  const handleCancel = () => {
    updateStateData(projectDetails);
    setPlotError('');
    setFileUploadError('');
    setStartDateError('');
    setEndDateError('');
    setPlotUploadFile(false);
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate('/')}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>{isEditing ? 'Edit Project' : 'View Project'}</span>
    </div>
  );

  console.log(uploadedGeoJSONLayer, 'uploadedGeoJSONLayer');
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {requestLoading && <Loader />}
          <Row>
            <Col>
              <Card className="mt-2">
                <FalconCardHeader
                  title={header}
                  className="px-lg-4"
                  titleTag="h5"
                  titleClass="mb-0"
                  light
                  endEl={
                    isEditable && (
                      <ButtonGroup className="d-flex align-items-center">
                        <ToggleButton
                          id="editing-false"
                          type="radio"
                          className="px-3 px-md-4 mb-0"
                          name="editingEnabled"
                          variant={!isEditing ? 'primary' : 'light'}
                          checked={!isEditing}
                          onChange={() => {
                            navigate(`/${tenant}/projects/${request_id}`);
                            updateStateData(projectDetails);
                          }}
                        >
                          View
                        </ToggleButton>
                        <ToggleButton
                          id="editing-true"
                          type="radio"
                          className="px-3 px-md-4 mb-0"
                          name="editingEnabled"
                          variant={isEditing ? 'primary' : 'light'}
                          checked={isEditing}
                          onChange={() => navigate('edit')}
                        >
                          Edit
                        </ToggleButton>
                      </ButtonGroup>
                    )
                  }
                ></FalconCardHeader>
                <Card.Body className="p-lg-4">
                  <Form onSubmit={handleSubmit}>
                    <Form.Group
                      className="mb-4"
                      controlId="formBasicProjectInfo"
                    >
                      <Row className="g-3 g-lg-4">
                        <Col lg={4}>
                          <Form.Label>Country</Form.Label>
                          <Form.Control
                            type="text"
                            readOnly
                            value={projectDetails?.country || ''}
                          />
                        </Col>
                        <Col lg={4}>
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            type="text"
                            readOnly
                            value={projectDetails?.state || ''}
                          />
                        </Col>
                        <Col lg={4}>
                          <Form.Label>Project Name</Form.Label>
                          <Form.Control
                            type="text"
                            readOnly
                            value={projectDetails?.project_name || ''}
                          />
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="formMonitoringInfo">
                      <Row className="g-3 g-lg-4">
                        <Col lg={4}>
                          <Row>
                            <Col>
                              <Form.Label>Enable Evaluation</Form.Label>
                              <ButtonGroup className="d-block">
                                <ToggleButton
                                  id="evaluationEnabled-false"
                                  disabled={!isEvaluationEditable}
                                  type="radio"
                                  className="px-3"
                                  name="evaluationEnabled"
                                  variant={
                                    !evaluationEnabled ? 'primary' : 'light'
                                  }
                                  checked={!evaluationEnabled}
                                  onChange={() => setEvaluationEnabled(false)}
                                >
                                  No
                                </ToggleButton>
                                <ToggleButton
                                  id="evaluationEnabled-true"
                                  disabled={!isEvaluationEditable}
                                  type="radio"
                                  className="px-3"
                                  name="evaluationEnabled"
                                  variant={
                                    evaluationEnabled ? 'primary' : 'light'
                                  }
                                  checked={evaluationEnabled}
                                  onChange={() => setEvaluationEnabled(true)}
                                >
                                  Yes
                                </ToggleButton>
                              </ButtonGroup>
                            </Col>
                            <Col>
                              <Form.Label>Enable Monitoring</Form.Label>
                              <ButtonGroup className="d-block">
                                <ToggleButton
                                  id="monitoringEnabled-false"
                                  disabled={!isMonitoringEditable}
                                  type="radio"
                                  className="px-3"
                                  name="monitoringEnabled"
                                  variant={
                                    !monitoringEnabled ? 'primary' : 'light'
                                  }
                                  checked={!monitoringEnabled}
                                  onChange={() => setMonitoringEnabled(false)}
                                >
                                  No
                                </ToggleButton>
                                <ToggleButton
                                  id="monitoringEnabled-true"
                                  disabled={!isMonitoringEditable}
                                  type="radio"
                                  className="px-3"
                                  name="monitoringEnabled"
                                  variant={
                                    monitoringEnabled ? 'primary' : 'light'
                                  }
                                  checked={monitoringEnabled}
                                  onChange={() => setMonitoringEnabled(true)}
                                >
                                  Yes
                                </ToggleButton>
                              </ButtonGroup>
                            </Col>
                          </Row>
                        </Col>

                        <Col
                          lg={4}
                          className={!monitoringEnabled && 'opacity-50'}
                        >
                          <Form.Label>Monitoring Date Range</Form.Label>
                          <Row className="g-0">
                            <Col
                              className={classNames(' me-2', {
                                'form-control is-invalid p-0': startDateError
                              })}
                            >
                              <DatePicker
                                disabled={!monitoringEnabled}
                                readOnly={!isMonitoringEditable}
                                selected={monitoringStartDate}
                                onChange={date => {
                                  setMonitoringStartDate(date);
                                  setStartDateError('');
                                }}
                                placeholderText="From"
                                minDate={new Date()}
                              />
                            </Col>

                            <Col
                              className={classNames(' ms-2', {
                                'form-control is-invalid p-0': endDateError
                              })}
                            >
                              <DatePicker
                                disabled={
                                  !monitoringEnabled || !monitoringStartDate
                                }
                                readOnly={!isMonitoringEditable}
                                selected={monitoringEndDate}
                                onChange={date => {
                                  setMonitoringEndDate(date);
                                  setEndDateError('');
                                }}
                                placeholderText="To"
                                minDate={monitoringStartDate}
                                maxDate={
                                  !isEmpty(monitoringStartDate)
                                    ? new Date(
                                        monitoringStartDate.getFullYear() + 3,
                                        monitoringStartDate.getMonth(),
                                        monitoringStartDate.getDate()
                                      )
                                    : null
                                }
                              />
                            </Col>
                            {(endDateError || startDateError) && (
                              <div className="invalid-feedback">
                                Please select a valid date range.
                              </div>
                            )}
                          </Row>
                        </Col>
                        <Col
                          lg={4}
                          className={!monitoringEnabled && 'opacity-50'}
                        >
                          <Form.Label>Frequency</Form.Label>
                          <Form.Select
                            className={classNames({
                              'bg-white': !isDark,
                              'opacity-100': !isMonitoringEditable
                            })}
                            disabled={
                              !monitoringEnabled || !isMonitoringEditable
                            }
                            aria-label="Monitoring Frequency select"
                            value={frequency}
                            onChange={e => setFrequency(e.target.value)}
                          >
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Half-Yearly">Half-Yearly</option>
                            <option value="Yearly">Yearly</option>
                          </Form.Select>
                        </Col>
                      </Row>
                    </Form.Group>
                    {isMapEditable && (
                      <Form.Group className="mb-4" controlId="formPlotInfo">
                        <Row className="g-3 g-lg-4">
                          <Col lg={4}>
                            <Form.Label>Plot Boundary</Form.Label>
                            <ButtonGroup className="d-block">
                              <ToggleButton
                                id="plotUploadFile-false"
                                type="radio"
                                className="px-4"
                                name="plotUploadFile"
                                variant={!plotUploadFile ? 'primary' : 'light'}
                                checked={!plotUploadFile}
                                onChange={() => {
                                  setPlotUploadFile(false);
                                  setFileName('');
                                  setGeojsonData({});
                                  setUploadedGeoJSONLayer(null);
                                  setHasLayer(false);
                                  featureGroupRef.current.clearLayers();
                                }}
                              >
                                Draw
                              </ToggleButton>
                              <ToggleButton
                                id="plotUploadFile-true"
                                type="radio"
                                className="px-4"
                                name="plotUploadFile"
                                variant={plotUploadFile ? 'primary' : 'light'}
                                checked={plotUploadFile}
                                onChange={() => {
                                  setPlotUploadFile(true);
                                  setHasLayer(true);
                                  featureGroupRef.current.clearLayers();
                                }}
                              >
                                Upload
                              </ToggleButton>
                            </ButtonGroup>
                          </Col>
                          {plotUploadFile && (
                            <>
                              <Col lg={4}>
                                <Form.Label>
                                  Upload Boundary File
                                  <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={UploadBoundaryFilePopover}
                                  >
                                    <span>
                                      <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        className="ms-1 text-light"
                                        id="uploadBoundaryFileTooltip"
                                      />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                                <div
                                  className={classNames(' input-group', {
                                    'form-control is-invalid p-0':
                                      fileUploadError
                                  })}
                                  onClick={handleFileUploadClick}
                                >
                                  <Form.Control
                                    type="text"
                                    readOnly
                                    value={fileName}
                                    placeholder="Select a file"
                                  />
                                  <span className="input-group-text px-2 rounded-1">
                                    <FontAwesomeIcon icon={faFileUpload} />
                                  </span>

                                  <input
                                    id="uploadBoundaryFileInput"
                                    hidden
                                    type="file"
                                    onChange={handleFileChange}
                                  />
                                </div>
                                {fileUploadError && (
                                  <Form.Text className="text-danger">
                                    {fileUploadError}
                                  </Form.Text>
                                )}
                              </Col>
                              <Col lg={4}>
                                <Form.Label>
                                  Download Boundary Templates
                                  <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={DownloadBoundaryTemplatePopover}
                                  >
                                    <span>
                                      <FontAwesomeIcon
                                        icon="info-circle"
                                        className="ms-1 text-light"
                                        id="downloadBoundaryTemplatesTooltip"
                                      />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                                <Form.Select
                                  className={!isDark && 'bg-white'}
                                  aria-label="Download Boundary Templates"
                                  placeholder="Download Template"
                                  value={''}
                                  onChange={handleDownloadTemplate}
                                >
                                  <option value="" disabled>
                                    Download Template
                                  </option>
                                  <option value="geojson">
                                    GeoJSON Template
                                  </option>
                                  <option value="wkt">{`WKT Template (.csv)`}</option>
                                </Form.Select>
                              </Col>
                            </>
                          )}
                        </Row>
                      </Form.Group>
                    )}

                    <Col
                      className={classNames('rounded-3 overflow-hidden', {
                        'border border-2 border-danger': plotError
                      })}
                    >
                      <MapContainer
                        id="map"
                        style={{ minHeight: '400px' }}
                        className="h-100 bg-white w-100 "
                        center={{ lat: 24.4539, lng: 54.3773 }}
                        zoom={1.8}
                        minZoom={1.3}
                        zoomSnap={0.5}
                        whenReady={mapInstance => {
                          mapRef.current = mapInstance;
                        }}
                        ref={mapRef}
                      >
                        <MapLayers
                          plotUploadFile={plotUploadFile}
                          uploadedGeoJSONLayer={uploadedGeoJSONLayer}
                          featureGroupRef={featureGroupRef}
                          isMapEditable={isMapEditable}
                          hasLayer={hasLayer}
                          _onCreate={_onCreate}
                          _onEdited={_onEdited}
                          _onDeleted={_onDeleted}
                        />
                        <TileLayer
                          attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a>'
                          url={`https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_PUBLIC_KEY}`}
                        />
                      </MapContainer>
                    </Col>
                    <span className="text-danger fs--1">{plotError}</span>
                    {/* <Col>
                      <pre className="text-left">
                        <span>Area: {Math.round(area)} h</span>
                        <br />
                        {JSON.stringify(geojsonData, 0, 2)}
                      </pre>
                    </Col> */}
                    {isEditing && (
                      <Col className="d-flex justify-content-end mt-4">
                        <Button
                          className="me-3"
                          onClick={handleCancel}
                          variant="light"
                        >
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                          Submit
                        </Button>
                      </Col>
                    )}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default EditProject;
